import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface EmployeeType {
  id?: string
  countryId: string
  name: string
  code: string
  customFields: any
}

export async function getEmployeeTypes(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['country_id = :countryId']
  if (search) {
    where.push(
      `CONCAT(employee_types.name, employee_types.code) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS numeric) ELSE NULL END), code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_employee_types'],
    fields: ['id', 'name', 'code', 'updated_at'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getEmployeeType(id: string): Promise<EmployeeType> {
  const data = await getData<any>({
    tables: ['pg_employee_types'],
    fields: ['id', 'name', 'code', 'country_id', 'custom_fields as custom'],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createEmployeeType(data: EmployeeType): Promise<boolean> {
  const response: any = await http.post('employee/types', {
    countryId: data.countryId,
    name: data.name,
    code: data.code,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateEmployeeType(
  data: EmployeeType,
  id: string
): Promise<boolean> {
  const response: any = await http.put('employee/types/' + id, {
    countryId: data.countryId,
    name: data.name,
    code: data.code,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteEmployeeType(id: string): Promise<boolean> {
  const response: any = await http.delete('employee/types/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
